import { createRoot } from 'react-dom/client'
import './index.css'
import App  from './App'

const pexel = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260`
const images = [
  { position: [0, 0, 1.5], rotation: [0, 0, 0], url: '/images/Test3.jpg', info: 'Per Aspera. Ad Astra.' },
  { position: [-0.8, 0, -0.6], rotation: [0, 0, 0], url: '/images/four.jpg', info: 'Literally the Red Planet.' },
  { position: [0.8, 0, -0.6], rotation: [0, 0, 0], url: '/images/two.jpg', info: 'Fly me to the Moon.' },
  // Left
  { position: [-1.75, 0, 0.25], rotation: [0, Math.PI / 2.5, 0], url:'/images/three.jpg', info: 'Chinmay HS' },
  { position: [-2.15, 0, 1.5], rotation: [0, Math.PI / 2.5, 0], url: '/images/five.jpg', info: 'LinkedIn MOG' },
  { position: [-2, 0, 2.75], rotation: [0, Math.PI / 2.5, 0], url: '/images/one.jpg', info: 'Lavender using Blender' },
  // Right
  { position: [1.75, 0, 0.25], rotation: [0, -Math.PI / 2.5, 0], url: '/images/seven.jpg', info: 'Goonj 2K24' },
  { position: [2.15, 0, 1.5], rotation: [0, -Math.PI / 2.5, 0], url: '/images/six.jpg', info: 'Editing Workflow' },
  { position: [2, 0, 2.75], rotation: [0, -Math.PI / 2.5, 0], url: '/images/eight.jpg', info: 'Environment in UE 5.2' }
];

createRoot(document.getElementById('root')).render(<App images={images} />);
